import { axiosInstance } from '../../../common/axiosInstans';
import {
    Drug,
    DrugByBarCodeResponse,
    DrugByGTINResponse,
} from '../../../application/types/drug.ts';

class DrugService {
    async getDrugByBarcode(barcode: string): Promise<DrugByBarCodeResponse> {
        try {
            const { data } = await axiosInstance.get(
                `/drug/barcode/${barcode}`
            );
            return data;
        } catch (error) {
            console.error('Error getting drug from barcode:', error);
            throw error;
        }
    }

    async getDrugByGtin(gtin: string): Promise<DrugByGTINResponse> {
        try {
            const { data } = await axiosInstance.get(`/drug/gtin/${gtin}`);
            return data;
        } catch (error) {
            console.error('Error getting drug from GTIN:', error);
            throw error;
        }
    }

    async getDrugById(id: string): Promise<Drug> {
        try {
            const { data } = await axiosInstance.get(`/drug/${id}`);
            return data;
        } catch (error) {
            console.error('Error getting drug by id:', error);
            throw error;
        }
    }
}

export default DrugService;
